import {
  GET_INTEGRATION_LINKAGE_REQUEST,
  GET_INTEGRATION_LINKAGE_SUCCESS,
  GET_INTEGRATION_LINKAGE_FAILURE,
  GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_REQUEST,
  GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_SUCCESS,
  GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_FAILURE,
  GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_REQUEST,
  GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_SUCCESS,
  GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_FAILURE,
  UPDATE_INTEGRATION_LINKAGE_REQUEST,
  UPDATE_INTEGRATION_LINKAGE_SUCCESS,
  UPDATE_INTEGRATION_LINKAGE_FAILURE,
  DELETE_INTEGRATION_LINKAGE_REQUEST,
  DELETE_INTEGRATION_LINKAGE_SUCCESS,
  DELETE_INTEGRATION_LINKAGE_FAILURE,
  CREATE_INTEGRATION_LINKAGE_REQUEST,
  CREATE_INTEGRATION_LINKAGE_SUCCESS,
  CREATE_INTEGRATION_LINKAGE_FAILURE,
  GET_ALL_WEBHOOK_INTEGRATIONS_REQUEST,
  GET_ALL_WEBHOOK_INTEGRATIONS_SUCCESS,
  GET_ALL_WEBHOOK_INTEGRATIONS_FAILURE,
  GET_INTEGRATION_LINKAGE_LENDERS_REQUEST,
  GET_INTEGRATION_LINKAGE_LENDERS_SUCCESS,
  GET_INTEGRATION_LINKAGE_LENDERS_FAILURE,
} from '../constants/actionTypes'

const initialState = {
  isFetching: false,
  errorMessage: '',
  lendersForLinking: [],
  externalProducts: [],
  productLink: {},
  companyIntegrationLinkages: [],
  webhookIntegrations: [],
}

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_INTEGRATION_LINKAGE_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case GET_INTEGRATION_LINKAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        productLink: action.data,
        // If we just got a new integration linkage then we want to reset the addons that we had previously loaded
        jobTypeAddonsAvailable: {},
      }
    case GET_INTEGRATION_LINKAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
      }

    case GET_INTEGRATION_LINKAGE_LENDERS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case GET_INTEGRATION_LINKAGE_LENDERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        lendersForLinking: action.data,
      }
    case GET_INTEGRATION_LINKAGE_LENDERS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
      }

    case GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        lenderProducts: [],
      }
    case GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        lenderProducts: action.data,
      }
    case GET_INTEGRATION_LINKAGE_LENDER_PRODUCTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
      }

    case GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_REQUEST:
      return {
        ...state,
        isFetchingExternalProducts: true,
      }
    case GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_SUCCESS:
      return {
        ...state,
        isFetchingExternalProducts: false,
        externalProducts: action.data,
      }
    case GET_INTEGRATION_LINKAGE_EXTERNAL_PRODUCTS_FAILURE:
      return {
        ...state,
        isFetchingExternalProducts: false,
        errorMessage: action.message,
      }
    case CREATE_INTEGRATION_LINKAGE_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case CREATE_INTEGRATION_LINKAGE_SUCCESS:
    {
      const updatedLinkage = action.data
      const idOfUpdatedLinkage = action.data.id
      const linkages = state.companyIntegrationLinkages
      let idxToUpdate = null

      linkages.forEach((linkage, idx) => {
        if (linkage.id === idOfUpdatedLinkage) {
          idxToUpdate = idx
        }
      })

      const updatedIntegrationLinkages = [
        ...linkages.slice(0, idxToUpdate),
        updatedLinkage,
        ...linkages.slice(idxToUpdate + 1),
      ]

      return {
        ...state,
        isFetching: false,
        companyIntegrationLinkages: updatedIntegrationLinkages,
      }
    }
    case CREATE_INTEGRATION_LINKAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
      }
    case UPDATE_INTEGRATION_LINKAGE_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case UPDATE_INTEGRATION_LINKAGE_SUCCESS:
    {
      const updatedLinkage = action.data
      const idOfUpdatedLinkage = action.data.id
      const linkages = state.companyIntegrationLinkages
      let idxToUpdate = null

      linkages.forEach((linkage, idx) => {
        if (linkage.id === idOfUpdatedLinkage) {
          idxToUpdate = idx
        }
      })

      const updatedIntegrationLinkages = [
        ...linkages.slice(0, idxToUpdate),
        updatedLinkage,
        ...linkages.slice(idxToUpdate + 1),
      ]

      return {
        ...state,
        isFetching: false,
        companyIntegrationLinkages: updatedIntegrationLinkages,
      }
    }

    case UPDATE_INTEGRATION_LINKAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
      }
    case DELETE_INTEGRATION_LINKAGE_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case DELETE_INTEGRATION_LINKAGE_SUCCESS:
    {
      const idOfDeletedLinkage = action.data
      const linkages = state.companyIntegrationLinkages
      let idxToUpdate = null

      linkages.forEach((linkage, idx) => {
        if (linkage.id === idOfDeletedLinkage) {
          idxToUpdate = idx
        }
      })

      const updatedIntegrationLinkages = [
        ...linkages.slice(0, idxToUpdate),
        ...linkages.slice(idxToUpdate + 1),
      ]

      return {
        ...state,
        isFetching: false,
        companyIntegrationLinkages: updatedIntegrationLinkages,
      }
    }
    case DELETE_INTEGRATION_LINKAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
      }

    case GET_ALL_WEBHOOK_INTEGRATIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case GET_ALL_WEBHOOK_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        webhookIntegrations: action.data,
      }
    case GET_ALL_WEBHOOK_INTEGRATIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
      }
    default:
      return state
  }
}
